import { DecisionAction, DecisionDetail } from "../../../models/home";
import { HomeDecisionActionUxService } from "../../../services/home-ia/home-decision-action-ux.service";
import { DecisionActionRequestEvent } from "./home-decision-detail.types";

/** Builds typed action events without depending on the Angular component. */
export class HomeDecisionDetailActionDispatcher {
  constructor(private readonly actionUx: HomeDecisionActionUxService) {}

  buildPrimaryRequest(detail: DecisionDetail | null, action: DecisionAction | null): DecisionActionRequestEvent | null {
    return this.buildRequest(detail, action, undefined);
  }

  buildFormRequest(
    detail: DecisionDetail | null,
    action: DecisionAction | null,
    formValue: Record<string, unknown>
  ): DecisionActionRequestEvent | null {
    return this.buildRequest(detail, action, formValue);
  }

  private buildRequest(
    detail: DecisionDetail | null,
    action: DecisionAction | null,
    formValue: Record<string, unknown> | undefined
  ): DecisionActionRequestEvent | null {
    const decisionId = detail?.decision?.decisionId;
    const request = this.actionUx.buildRequest(action, formValue);
    return decisionId && action?.actionKey && request
      ? { decisionId, actionKey: action.actionKey, request }
      : null;
  }
}
